import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  agreements: []
};

export const agreementSlice = createSlice({
  name: 'agreement',
  initialState,
  reducers: {
    setAgreement: (state, action) => {
      state.agreements = action.payload;
    }
  }
});

export const { setAgreement } = agreementSlice.actions;
export default agreementSlice.reducer;
